import React from "react";
import "../Css/ResearchAdvocacy.css";
import ResearchAdvocacyBanner from "../Assets/Research&Advocacy.jpeg";

const ResearchAdvocacy = () => {
  return (
    <div className="ra-wrapper">
      <div className="ra-hero">
        <img
          src={ResearchAdvocacyBanner}
          alt="SportsForEquity research, policy, and advocacy"
          className="ra-hero-img"
        />
      </div>

      <div className="ra-container">
        <h2 className="ra-title">Research, Policy &amp; Advocacy</h2>

        <p className="ra-text">
          SportsForEquity connects recurring community programs with public-health research, responsible data use, and evidence-informed advocacy. We evaluate program reach, accessibility, participant experience, youth leadership, and sustainability, then share those findings with public-health professionals, Parkinson's organizations, community partners, and policymakers.
        </p>        
        <h3 className="ra-subheading">Research & Program Evaluation</h3>
        <ul className="ra-list">
          <li>American Public Health Association</li>
          <li>Washington State Public Health Association</li>
        </ul>

        <h3 className="ra-subheading">Policy Issue Briefs</h3>
        <p className="ra-text">Progress is underway!</p>

        <h3 className="ra-subheading">Public-Health Advocacy</h3>
        <ul className="ra-list">
          <li>American Parkinson Disease Association constituent advocacy campaigns</li>
          <li>HEALTHY BRAINS Act (H.R. 7779)</li>
          <li>American Parkinson Disease Association campaign to increase NIH funding for Parkinson's research</li>
        </ul>
      </div>
    </div>
  );
};

export default ResearchAdvocacy;